/**
 * Created by klerick on 27.12.16.
 */
'use strict';
angular.module('webtrader').service('OpenListMarket', function($q, $document, OpenListOptions) {

    let _currentStatus = false;
    let _openPromise;

    let onClick = () => {
        this.close();
    };

    this.open = function (type, data) {
        _currentStatus = true;
        _openPromise = $q.defer();
        OpenListOptions.close();
        setTimeout(() => {
            $document.on('click', onClick) ;
        }, 500);


        return _openPromise.promise;
    };


    this.close = function (data) {
        _currentStatus = false;

        if (_openPromise && _openPromise.resolve) {
            _openPromise.resolve();
            _openPromise = '';
        }

        $document.off('click', onClick);
    };

    Object.defineProperties(this, {
        isOpen: {
            get: function () {
                return _currentStatus;
            }
        }

    });
});
